import { App } from 'antd'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { deleteSourceMap } from '../service/sourceMapService'
import sourceMapQueryKeys from './sourceMapQueryKeys'

interface DeleteSourceMapVariables {
  id: number
  // Skip the per-call success toast, e.g. when the caller batches several deletes under one action
  // and shows a single aggregate toast itself.
  silent?: boolean
}

export const useDeleteSourceMap = () => {
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({ id }: DeleteSourceMapVariables) => deleteSourceMap(id),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: sourceMapQueryKeys.all })
      if (!variables.silent) {
        message.success(t('messages:deleteSuccess', 'Poistettu'))
      }
    },
    onError: () => {
      message.error(t('messages:deleteError', 'Poisto epäonnistui'))
    }
  })
}
